export function groupByCategory(tools) {
  const map = new Map();
  tools.forEach((tool) => {
    const name = tool.category || 'Uncategorized';
    if (!map.has(name)) map.set(name, { name, tools: [] });
    map.get(name).tools.push(tool);
  });
  return Array.from(map.values());
}

export function matchesTool(tool, q) {
  const s = (q || '').trim().toLowerCase();
  if (!s) return true;
  return [tool.name, tool.description, tool.category]
    .some((v) => (v || '').toLowerCase().includes(s));
}

/** Recent rows joined to the caller's current catalog; revoked tools drop out. */
export function joinRecent(recentRows, tools) {
  const byId = new Map(tools.map((t) => [t.id, t]));
  return recentRows
    .filter((r) => byId.has(r.tool_id))
    .map((r) => ({ tool: byId.get(r.tool_id), lastUsedAt: r.last_used_at }));
}
